import { FaqSection } from './faqTypes';
import { USERS_ACCESS_SECTION } from './faqUsersAccess';
import { HARDWARE_SECTION } from './faqHardware';
import { PRODUCT_SECTION } from './faqProduct';
import { COMMERCIAL_SECTION } from './faqCommercial';

// The assembled FAQ, rendered by both the page and the PDF so the two can
// never drift apart.

export const FAQ_TITLE = 'DATA 360 commercial FAQ';

export const FAQ_SUBTITLE =
  'How users, hardware, data, and retention are priced, and which answers are still open.';

export const FAQ_INTRO =
  'These are the commercial questions that come up before a DATA 360 quote can be written. Each answer is marked with how settled it is, so nothing here is mistaken for an agreed position when it is still a recommendation.';

export const FAQ_SECTIONS: FaqSection[] = [
  USERS_ACCESS_SECTION,
  HARDWARE_SECTION,
  PRODUCT_SECTION,
  COMMERCIAL_SECTION,
];

export const FAQ_ITEM_COUNT = FAQ_SECTIONS.reduce(
  (total, section) => total + section.items.length,
  0
);
